var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMontenegrin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 15,
    viewBox: "0 0 21 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_montenegrin_flag)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 15,
    rx: 3,
    fill: "#D4AF37"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 19.5,
    height: 13.5,
    rx: 2.25,
    fill: "#C40308"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 3.6L11.3 4.9L12.4 4.2L12 5.7L14 5.5L12.6 6.9L14.4 7.7L12.4 8.1L13.2 9.7L11.4 9.1L11.2 10.9L10.5 9.9L9.8 10.9L9.6 9.1L7.8 9.7L8.6 8.1L6.6 7.7L8.4 6.9L7 5.5L9 5.7L8.6 4.2L9.7 4.9Z",
    fill: "#D4AF37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.3 3.7L10.5 2.7L11.7 3.7L11.5 4.2H9.5Z",
    fill: "#D4AF37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.4 6.8H11.6V8.6C11.6 9.3 11.1 9.7 10.5 9.9C9.9 9.7 9.4 9.3 9.4 8.6Z",
    fill: "#1F4E9C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_montenegrin_flag"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 15,
    rx: 3,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMontenegrin);
export default __webpack_public_path__ + "static/media/montenegrin.ed4326897dba92621a2480f344743f21.svg";
export { ForwardRef as ReactComponent };